export default __webpack_public_path__ + "static/media/login-illustration.c2aa89e6.svg";